import React from 'react';
import dateTimeHelper from '../../../Helpers/datetimeHelper';

function logProps(WrappedComponent) {
  class LogProps extends React.Component {
    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return LogProps;
}

class CustomDateInput extends React.Component {
  render() {
    return (
      <span
        className='ds-datetrigger'
        onClick={() => this.props.onClick()}
      >
        {this.props.value ? (
          dateTimeHelper.toYYYYsMMsDD(this.props.value, '-')
        ) : (
          <span className='text-muted'>Select date</span>
        )}
      </span>
    );
  }
}

//export const ref = React.createRef();

export default logProps(CustomDateInput);
